import { useCallback, useState } from 'react';

export interface RecruitingAuditionsSearch {
  keyword?: string;
}

export function useRecruitingAuditionsSearch(initial?: RecruitingAuditionsSearch): {
  setSearchParam: (param: RecruitingAuditionsSearch) => void;
  searchParam: RecruitingAuditionsSearch;
  setKeyword: (keyword: string) => void;
  filter: <T extends { title: string; detail: string }>(auditions: T[]) => T[];
} {
  const [searchParam, setSearchParam] = useState<RecruitingAuditionsSearch>(initial ?? {});
  const setKeyword = (keyword: string) => setSearchParam({ ...searchParam, keyword });
  const filter = useCallback(
    <T extends { title: string; detail: string }>(auditions: T[]) => {
      return auditions.filter((audition) => {
        if (!searchParam.keyword) return true;
        return (
          audition.title.includes(searchParam.keyword) ||
          audition.detail.includes(searchParam.keyword)
        );
      });
    },
    [searchParam.keyword]
  );

  return {
    setSearchParam,
    searchParam,
    setKeyword,
    filter,
  };
}
